import { useAdParams } from '../../../hooks/useAdParams';

const BOOKING_URL = 'https://nekonosenaka.hot-yoyaku.net/e_repeat/cbe/users?u=s3hm7veyo0&k=mirror&s=c-c-r/15';

export default function About() {
  const { appendParams } = useAdParams();
  const bookingUrl = appendParams(BOOKING_URL);

  const concerns = [
    '妊娠前のズボンが履ける気がしない',
    '抱っこで肩・腰がツラい',
    '産後のお腹が元に戻らない',
    '気のせいだと言い聞かせて鏡を見るのを避けている',
  ];

  return (
    <div className="bg-white">
      {/* 背景画像＋オーバーレイセクション */}
      <div className="relative w-full overflow-hidden" style={{ minHeight: '420px' }}>
        <img
          src="https://static.readdy.ai/image/d50572b1dfc4f7f997ef99fe23e21a49/353b05ff4ac46f5912e35959d8ef4d7e.png"
          alt="産後ママのイラスト"
          className="w-full h-full object-cover object-top absolute inset-0"
          style={{ minHeight: '420px' }}
        />
        <div className="absolute inset-0 bg-white/60"></div>
        <div className="relative z-10 flex flex-col items-center justify-start px-6 pt-6 pb-8" style={{ minHeight: '420px' }}>
          <div className="w-full max-w-sm mb-6 text-center">
            <h2 className="text-xl font-bold text-[#5C3A1E] leading-relaxed">
              産後、自分の身体のケア<br />後回しになっていませんか？
            </h2>
          </div>
          <div className="space-y-4 w-full max-w-sm mb-4">
            {concerns.map((concern, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="bg-orange-400 rounded-md flex-shrink-0 w-6 h-6 flex items-center justify-center mt-0.5">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <p className="text-[#5C3A1E] text-base font-medium leading-relaxed">{concern}</p>
              </div>
            ))}
          </div>
          <div className="w-full max-w-sm bg-white/40 backdrop-blur-sm rounded-xl px-5 py-4 border border-orange-200">
            <p className="text-[#5C3A1E] text-base leading-loose text-center font-medium">
              この症状・・・<br />
              放っておくと元に戻らないだけでなく、<br />
              <span className="text-orange-600 font-bold">尿漏れや子宮脱の原因</span><br />
              になることがあります。
            </p>
          </div>
        </div>
      </div>

      {/* 説明セクション */}
      <div className="max-w-md mx-auto px-4 py-8">
        <div className="border-t border-yellow-200 pt-8">

          {/* M.Mさん ビフォーアフター */}
          <div className="mb-8">
            <p className="text-center text-xs text-orange-600 font-semibold mb-2 tracking-wide">＼ ビフォーアフター ／</p>
            <div className="w-full rounded-xl overflow-hidden" style={{ height: '240px' }}>
              <img
                src="https://static.readdy.ai/image/d50572b1dfc4f7f997ef99fe23e21a49/c5d3d771391e429906e59cb7ca770f11.png"
                alt="M.Mさん ビフォーアフター"
                className="w-full h-full object-cover"
                style={{ objectPosition: '50% 30%' }}
              />
            </div>
            <p className="text-center text-xs text-gray-500 mt-2">M.Mさん（30代）産後骨盤矯正のビフォーアフター</p>
          </div>

          <h3 className="text-lg font-bold text-gray-800 mb-5 text-center">
            なぜ、産後に骨盤ケアが必要なの？
          </h3>

          <div className="space-y-2 mb-6 px-1">
            <p className="text-gray-700 leading-snug text-sm text-center">
              出産は<br />
              <span className="font-bold text-orange-600 text-base">交通事故レベルのダメージ</span><br />
              <br />
              とも言われています。
            </p>
            <p className="text-gray-700 leading-snug text-sm text-center">
              赤ちゃんを守り、産み出した身体は<br />
              骨盤が開き、筋肉や靭帯も引き伸ばされ<br />
              とても不安定な状態です。
            </p>
            <p className="text-gray-700 leading-snug text-sm text-center">
              それでもママは<br />
              休む間もなく育児がスタートします。
            </p>
            <div className="flex flex-col items-center gap-1 py-1">
              {['抱っこ', '授乳', '寝不足の毎日…'].map((item, i) => (
                <span key={i} className="text-[#5C3A1E] font-semibold text-base">{item}</span>
              ))}
            </div>
            <p className="text-gray-700 leading-snug text-sm text-center">
              自分の身体のケアは<br />
              どうしても後回しになりがちです。
            </p>
            <p className="text-gray-700 leading-snug text-sm text-center font-medium">
              でも実は、
            </p>
            <div className="bg-orange-50 border border-orange-200 rounded-xl px-5 py-4 text-center">
              <p className="text-[#5C3A1E] font-bold text-base leading-snug">
                産後の骨盤は<br />
                <span className="text-orange-600 text-lg">人生で一番整えやすいタイミング。</span>
              </p>
              <p className="text-gray-700 text-sm leading-relaxed mt-2">
                今しっかり整えておくことで<br />
                体型や不調の改善につながります。
              </p>
            </div>
            <p className="text-[#5C3A1E] font-semibold text-lg leading-relaxed text-center py-4">
              がんばってきた身体を<br />
              今こそ優しく整えてあげましょう。
            </p>

            {/* CTA */}
            <div className="bg-orange-50 border border-orange-200 rounded-xl px-5 py-5 text-center mt-2">
              <p className="text-orange-600 font-bold text-sm mb-1">＼産後骨盤矯正 初回限定／</p>
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="text-gray-400 line-through text-sm">通常8,800円</span>
                <span className="text-2xl font-bold text-orange-600">3,980<span className="text-base">円</span></span>
              </div>
              <a
                href={bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-lime-500 text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-lime-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full"
              >
                <i className="ri-calendar-check-line text-xl"></i>
                <span>今すぐ予約する</span>
              </a>
              <p className="text-gray-500 text-xs mt-2">託児あり・産後1ヶ月〜OK</p>
            </div>
          </div>

          {/* ① お客様の声（CTA直後） */}
          <div className="mt-8 mb-0">
            <h3 className="text-lg font-bold text-gray-800 text-center mb-5">お客様の声</h3>

            {/* U.Kさんのカード（1番目） */}
            <div className="bg-orange-50 border border-orange-100 rounded-xl overflow-hidden mb-4">
              <div className="w-full overflow-hidden" style={{ height: '220px' }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_35a054028ff22ed225a3fa80d2f2871c_506ea238.jpg"
                  alt="施術の様子"
                  className="w-full h-full object-cover"
                  style={{ display: 'block', objectPosition: '50% 50%' }}
                />
              </div>
              <div className="px-4 py-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-full bg-orange-200 flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-smile-line text-orange-600 text-base"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-800 text-sm">U.Kさん</p>
                    <p className="text-gray-500 text-xs">40代</p>
                  </div>
                  <div className="flex gap-0.5 ml-auto">
                    {[1,2,3,4,5].map((s) => (
                      <i key={s} className="ri-star-fill text-orange-400 text-sm"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed">
                  産後５ヶ月しても体重が全然戻らなくて諦めかけていましたが、佐川先生のところに通うたびにモチベーションもあがるし育児も自分の身体のことにも目を向けることができました。
                </p>
                <p className="text-xs text-gray-400 mt-2">※お客様個人の感想であり、効果には個人差があります。</p>
              </div>
            </div>

            {/* 口コミ多数バッジ＋画像（2番目） */}
            <div className="mb-8">
              <div className="text-center mb-3">
                <span className="inline-block bg-orange-500 text-white text-xs font-bold px-4 py-1.5 rounded-full tracking-wider">
                  口コミ多数！
                </span>
              </div>
              <div className="w-full rounded-xl overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/83ccbae5-54bc-40cd-94d4-3e8278454994/4d47ff6e-d978-4e31-97fe-be4fea715065_-2026-03-30-9.57.10.png?v=c9faadbb6c3fd47f336d455313f47990"
                  alt="口コミ多数"
                  className="w-full h-auto block"
                />
              </div>
              <p className="text-xs text-gray-400 mt-2 text-center">
                ※お客様個人の感想であり、効果には個人差があります。
              </p>
            </div>

            {/* お客様の声 下CTA */}
            <div className="bg-yellow-100 border border-yellow-300 rounded-xl px-5 py-5 text-center mb-8">
              <p className="text-orange-600 font-bold text-sm mb-1">＼産後骨盤矯正 初回限定／</p>
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="text-gray-400 line-through text-sm">通常8,800円</span>
                <span className="text-2xl font-bold text-orange-600">3,980<span className="text-base">円</span></span>
              </div>
              <a
                href={bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-lime-500 text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-lime-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full"
              >
                <i className="ri-calendar-check-line text-xl"></i>
                <span>今すぐ予約する</span>
              </a>
              <p className="text-gray-500 text-xs mt-2">託児あり・産後1ヶ月〜OK</p>
            </div>

          </div>

          {/* ② 骨盤の開きを放っておくと？（口コミの後） */}
          <img
            src="https://public.readdy.ai/ai/img_res/edited_f4ca90ba70a2a1fdea86d9a9a11ad190_506ea238.jpg"
            alt="骨盤の模型で説明"
            className="rounded-xl w-full h-48 object-cover mb-6"
          />

          <h4 className="text-base font-bold text-gray-800 mb-3 flex items-center gap-2 px-1">
            <i className="ri-alert-line text-orange-500 text-lg w-5 h-5 flex items-center justify-center"></i>
            骨盤の開きを放っておくと？
          </h4>

          <div className="space-y-3 px-1">
            <p className="text-gray-700 leading-relaxed text-sm">
              妊娠中、赤ちゃんが成長するにつれて骨盤は広がり、身体を支える筋肉や靭帯も大きく引き伸ばされます。
            </p>
            <p className="text-gray-700 leading-relaxed text-sm">
              出産後の骨盤は不安定で、<span className="font-bold text-orange-600">身体のバランスが崩れやすい状態</span>です。
            </p>
            <p className="text-gray-700 leading-relaxed text-sm">
              この状態のまま育児が始まると、抱っこや授乳など前かがみの姿勢が増え、<span className="font-bold text-orange-600">骨盤の歪みがそのまま身体のクセとして残ってしまいます。</span>
            </p>
            <p className="text-gray-700 leading-relaxed text-sm font-medium">その結果、</p>
            <ul className="space-y-1 pl-2">
              {['腰痛や肩こり', 'ぽっこりお腹', '体型の崩れ', '疲れやすさ'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="text-orange-500 font-bold">・</span>{item}
                </li>
              ))}
            </ul>
            <p className="text-gray-700 leading-relaxed text-sm">
              といった、産後特有の不調につながります。
            </p>
          </div>

          <div className="bg-yellow-50 mt-5 py-4 px-4 border-l-4 border-orange-400">
            <p className="text-gray-800 font-semibold text-sm">
              産後は、身体が元に戻ろうとする<span className="text-orange-600">骨盤を整えやすい大切なタイミング</span>です。この時期に骨盤を整えることで、体型と身体のバランスを戻しやすくなります。
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
